import sample from './sample.js';

// Shuffle a collection.
export default function shuffle(obj) {
  return sample(obj, Infinity);
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/shuffle.js
// module id = 1923
// module chunks = 1